import styled from 'styled-components'

export const Section = styled.section`
  margin-top: 102px;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: 900px) {
    margin-top: 64px;
    padding: 0 16px;
  }
`

export const Title = styled.h2`
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  font-size: 28px;
  line-height: 100%;
  text-align: center;
  color: #21105d;
  margin-bottom: 32px;

  @media (max-width: 900px) {
    font-size: 24px;
  }
`

export const CarouselWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
  max-width: 1440px;
`

export const Carousel = styled.div`
  display: flex;
  gap: 32px;
  justify-content: center;
  margin-bottom: 32px;
  transition: transform 0.3s ease;

  @media (max-width: 900px) {
    flex-direction: column;
    align-items: center;
  }
`

export const Card = styled.div`
  width: 402px;
  height: 282px;
  border-radius: 50px;
  background: #f8f9fd;
  padding: 32px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  @media (max-width: 900px) {
    width: 100%;
    max-width: 402px;
    height: auto;
    min-height: 282px;
  }
`

export const Text1 = styled.div`
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  font-size: 18px;
  line-height: 24px;
  color: #21105d;
  margin-bottom: 32px;
`

export const Text2 = styled.div`
  font-family: 'Inter', sans-serif;
  font-size: 18px;
  line-height: 24px;
  color: #21105d;

  strong {
    font-weight: 600;
  }

  br + strong {
    font-size: 16px;
    font-weight: 400;
    line-height: 22px;
  }
`

export const Bullets = styled.div`
  display: flex;
  gap: 12px;
  justify-content: center;

  @media (max-width: 900px) {
    display: none;
  }
`

export const Bullet = styled.button<{ active?: boolean }>`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  border: none;
  background: ${({ active }) => (active ? '#21105D' : '#D1D1E7')};
  cursor: pointer;
  transition: background 0.2s;
  padding: 0;

  &:hover {
    background: #21105d;
  }
`
